import React, { Component } from 'react';
import { Form, FormGroup, Label, Col, Row } from 'reactstrap';
import { Input } from '@progress/kendo-react-inputs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getCounties } from '../../../../../../Redux/Actions/Admin/ManageDistrictActions';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../api-config';
import { auth } from '../../../../../../services/auth.service';

import '../../../../../AdminView/Pages/Administration/ManageMembership/ManageMembership.scss';

class EditMembershipUserForm extends Component {
    constructor(props) {
		super(props);
		this.state = {
            email: this.props.membershipUserInEdit.userName || "",
            membershipId: this.props.membershipId,
            userID: '',
            membershipAssignmentId: this.props.membershipUserInEdit.membershipAssignmentId,
			MembershipPackageId:0,
			mailingStateId:44,
            firstName: this.props.membershipUserInEdit ? this.props.membershipUserInEdit.firstName : "",
            lastName: this.props.membershipUserInEdit ? this.props.membershipUserInEdit.lastName : "",
            mailingAddress1: this.props.membershipUserInEdit ? this.props.membershipUserInEdit.address1 : "",
			mailingAddress2: this.props.membershipUserInEdit ? this.props.membershipUserInEdit.address2 : "",
            mailingCity: this.props.membershipUserInEdit ? this.props.membershipUserInEdit.city : "",
            mailingZip: this.props.membershipUserInEdit ? this.props.membershipUserInEdit.zip : "",
            phone: this.props.membershipUserInEdit ? this.props.membershipUserInEdit.phone : "",
            memberSequenceNum: 1,
            organizationName: this.props.membershipUserInEdit.organizationName,
			stateObject: {
                id: this.props.membershipUserInEdit ? this.props.membershipUserInEdit.state.stateId : 0,
                name: this.props.membershipUserInEdit ? this.props.membershipUserInEdit.state.description : "",
            },
            County: {
                countyId: this.props.membershipUserInEdit ? this.props.membershipUserInEdit.countyId : 0,
                countyName: this.props.membershipUserInEdit.countyObj ? this.props.membershipUserInEdit.countyObj.description : ""
            },

            emailMessage: '',
            isMembershipOwner:false,
            ownerExists:this.props.ownerExists
		};

        this.handleSubmit = this.handleSubmit.bind(this);
	}
    componentDidMount() {
        if (this.state.stateObject.id != 0) {
            this.props.getCounties(this.state.stateObject.id);
        }
	}
	
	onDialogInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		})
    }

    handleState = (event) => {
        this.props.getCounties(event.target.value.id);
        console.log(event.target.value)
        this.setState({
            mailingStateId: event.target.value.id,
            stateObject: {
                id: event.target.value.id,
                name: event.target.value.name,
            }
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        let model = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            mailingAddress1: this.state.mailingAddress1,
            mailingAddress2: this.state.mailingAddress2,
            mailingCity: this.state.mailingCity,
            state: this.state.stateObject,
            county: this.state.County,
            mailingZip: this.state.mailingZip,
            phone: this.state.phone,
            email: this.state.email,
            membershipId: this.state.membershipId,
            membershipAssignmentId: this.state.membershipAssignmentId,
            organizationName: this.state.organizationName,
            mailingStateId:this.state.mailingStateId,
            isMembershipOwner:this.state.isMembershipOwner
        }

        axios.post(`${ROOT_API_URL}/MemberInvitation/IsDuplicateEmailOnEdit`, model, { headers: auth.authHeader() })
            .then((response) => {
                if (response.data.message != "") {
                    this.setState({
                        emailMessage: response.data.message
                    })
                }
                else {
                    axios.post(`${ROOT_API_URL}/MemberInvitation/UpdateMembershipUserInvite`, model, { headers: auth.authHeader() })
                        .then((response) => {
                            this.props.completeUpdatedInvite(model);
                        });
                }
            });
    }
    handleCheckboxChange = event => {
        this.setState({ isMembershipOwner: event.target.checked 
        });
    }
	render() {
        return (
            <div>
                <form className="additionalMembersForm user-form membership-form" onSubmit={this.handleSubmit}>
                <h1 className="pt-3 pb-3">Complete Invitation</h1>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="firstName">First Name</label>
                        <Input type="firstName" name="firstName" onChange={this.onDialogInputChange} value={this.state.firstName} />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="lastName">Last Name</label>
                        <Input type="lastName" name="lastName" onChange={this.onDialogInputChange} value={this.state.lastName}/>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="">Address1</label>
                        <Input type="text" name="mailingAddress1" onChange={this.onDialogInputChange} value={this.state.mailingAddress1}/>
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="">Address2</label>
                        <Input type="text" name="mailingAddress2" onChange={this.onDialogInputChange} value={this.state.mailingAddress2}/>
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="city">City</label>
                        <Input type="city" name="mailingCity" onChange={this.onDialogInputChange} value={this.state.mailingCity}/>
                    </div>
                    <div className="form-group col-md-3">
                        <label htmlFor="state">State</label>
                        <DropDownList data={this.props.common.states}
                            id="State"
                            name="state"
                            textField="name"
                            dataItemKey="id"
                            onChange={this.handleState}
                            value={this.state.stateObject}
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label htmlFor="County">County</label>
                            <DropDownList data={this.props.district.counties}
                            id="County"
                            name="County"
                            textField="countyName"
                            dataItemKey="countyId"
                            onChange={this.onDialogInputChange}
                            value={this.state.CountyObj}
                            // className={this.state.touched.state && this.state.CountyObj === null ? "error" : ""}
                            //onBlur={this.handleBlur('county')}
                        />
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="zip">Zip</label>
                        <Input type="zip" name="mailingZip" onChange={this.onDialogInputChange} value={this.state.mailingZip}/>
                    </div>
                    <div className="form-group col-md-6">
                        <label htmlFor="phone">Phone</label>
                        <Input type="phone" name="phone" onChange={this.onDialogInputChange} value={this.state.phone}/>
					</div>
				</div>
                <div className="row">
                    <div className="form-group col-md-6">
                        <label htmlFor="email">Email</label>
                            <Input
                                type="email"
                                name="email"
                                value={this.state.email}
                                onChange={this.onDialogInputChange}
                                //value={this.state.email}
                                required={true} />
                            <p className="error-message">{this.state.emailMessage}</p>
                    </div>
                    {auth.isInRole('INTERNAL')  && !this.props.ownerExists ? 
                        <div className="form-group col-md-6 membershipOwner">
                            <input
                                    type="checkbox"
                                    id="IsMembershipOwner"
                                    name="IsMembershipOwner"
                                    checked={this.state.isMembershipOwner}
                                    onChange={this.handleCheckboxChange}
                                />
                                <label htmlFor="IsMembershipOwner">
                                    <span className={ this.state.isMembershipOwner ? " far fa-check-square" : "far fa-square"}></span>
                                    <span className="custom-control-text">IsMebership Owner</span>
                                </label>
                        </div>
                :"" }
                    </div>
				{/* <FormGroup check>
					<Label check>
						<Input type="checkbox" /> Send Subscription
					</Label>
				</FormGroup> */}
            
            <div className="footer">
                <div className="form-group">
                        <button type="submit" className="btnPrimary" style={{height: "56px", width: "195px"}}>
                        <i className="fas fa-save" style={{fontSize:"20px"}}></i>
                        <span style={{fontSize:"20px", fontWeight: "bold"}}> SAVE</span>
                    </button>
                    <button className="btnSecondary admin-k-button cancel-btn" onClick={this.props.cancel}>
                        <i className="fas fa-times"></i>
                        <span>CANCEL</span>
                    </button>
                </div>
                    </div>
                </form>
            </div>
		);
	}
}
function mapStateToProps(state) {
    return {
        common: state.common,
        district: state.district
    }
}
export default withRouter(connect(mapStateToProps, { getCounties })(EditMembershipUserForm));
